// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILetterOfMedicalNecessityPatchDto
 */
export interface ILetterOfMedicalNecessityPatchDto {
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityPatchDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityPatchDto
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityPatchDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityPatchDto
     */
    valid_to?: Date;
}

/**
 * Check if a given object implements the ILetterOfMedicalNecessityPatchDto interface.
 */
export function instanceOfILetterOfMedicalNecessityPatchDto(value: object): value is ILetterOfMedicalNecessityPatchDto {
    return true;
}

export function ILetterOfMedicalNecessityPatchDtoFromJSON(json: any): ILetterOfMedicalNecessityPatchDto {
    return ILetterOfMedicalNecessityPatchDtoFromJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityPatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILetterOfMedicalNecessityPatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'] == null ? undefined : json['name'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function ILetterOfMedicalNecessityPatchDtoToJSON(json: any): ILetterOfMedicalNecessityPatchDto {
    return ILetterOfMedicalNecessityPatchDtoToJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityPatchDtoToJSONTyped(value?: ILetterOfMedicalNecessityPatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'name': value['name'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
    };
}

